export const nurzhauova = {
  id: 'nurzhauova',
  name: {
    ru: 'Нуржауова Нурлыкыз Кадирбеккызы',
    kz: 'Нұржауова Нұрлыкыз Қадірбекқызы',
  },
  position: {
    ru: 'Врач функциональной диагностики',
    kz: 'Функционалдық диагностика дәрігері',
  },
  department: 'diagnostics',
  image: '/team_photoes/new/nurzhaova.jpeg',
  experience: {
    ru: 'Более 9 лет',
    kz: '9 жылдан астам',
  },
  education: {
    ru: `2008–2013 — АО «Медицинский университет Астана», специальность «Общая медицина»
2013–2015 — АО «Медицинский университет Астана», интернатура по специальности «Внутренние болезни»
2015–2018 — Резидентура по специальности «Кардиология, в том числе детская» на базе КФ «UMC» Национальный научный центр онкологии и трансплантологии`,
    kz: `2008–2013 — «Астана медициналық университеті» АҚ, «Жалпы медицина» мамандығы
2013–2015 — «Астана медициналық университеті» АҚ, «Ішкі аурулар» мамандығы бойынша интернатура
2015–2018 — «UMC» ҰҒОО Ұлттық онкология және трансплантология ғылыми орталығы базасында «Кардиология, оның ішінде балалар кардиологиясы» мамандығы бойынша резидентура`,
  },
  specialization: {
    ru: `Кардиология
Функциональная диагностика
Эхокардиография
Холтеровское мониторирование ЭКГ и АД`,
    kz: `Кардиология
Функционалдық диагностика
Эхокардиография
ЭКГ және АҚ Холтерлік мониторингі`,
  },
  work: {
    ru: `• 07.2017–04.2019 — Врач-терапевт, приёмное отделение, ГКП на ПХВ «ГМБ №2»
- 10.2018–04.2019 — Врач-кардиолог (экстренный), отделение КардиоБИТ, ГКП на ПХВ «ГМБ №2»
- 09.04.2019–01.08.2024 — Врач-кардиолог, отдел ОАРИТ №2 кардиологического и кардиохирургического профиля, АО «Национальный научный медицинский центр»
- 02.12.2021–01.09.2022 — Врач-кардиолог, ГКП на ПХВ «Городская поликлиника №8»
- 10.09.2023 — по настоящее время — Врач-кардиолог, функционалист, Медико-консультативный центр «Сенім А»
- 01.09.2024 — по настоящее время — Врач ЭХОКГ для оказания экстренной помощи, Многопрофильная городская больница №1 г. Астана
- 19.01.2026 — по настоящее время — Врач функциональной диагностики, ГККП «Спортивный медицинский центр города Астаны»`,
    kz: `• 07.2017–04.2019 — Терапевт-дәрігер, қабылдау бөлімі, «ГМБ №2» ШЖҚ МКК
- 10.2018–04.2019 — Кардиолог-дәрігер (жедел), КардиоБИТ бөлімі, «ГМБ №2» ШЖҚ МКК
- 09.04.2019–01.08.2024 — Кардиолог-дәрігер, кардиология және кардиохирургия бейінді ЖРИТБ №2 бөлімі, «Ұлттық ғылыми медициналық орталық» АҚ
- 02.12.2021–01.09.2022 — Кардиолог-дәрігер, «№8 қалалық емхана» ШЖҚ МКК
- 10.09.2023 — қазіргі уақытқа дейін — Кардиолог-дәрігер, функционалист, «Сенім А» медициналық-кеңестік орталығы
- 01.09.2024 — қазіргі уақытқа дейін — Жедел жәрдем көрсету үшін ЭХОКГ дәрігері, Астана қаласының көпсалалы қалалық аурухана №1
- 19.01.2026 — қазіргі уақытқа дейін — Функционалдық диагностика дәрігері, ГККП «Астана қаласының Спорттық медициналық орталығы»`,
  },
  certificates: {
    ru: `Курсы повышения квалификации (за последние 5 лет):
- 2023 — Цикл «Основы эхокардиографии у детей» (240 часов), НАО «Национальный научный кардиохирургический центр» (свидетельство №362)
- 2023 — Цикл «Интервенционные технологии в кардиологии» (120 часов), РГП на ПХВ «Казахский научный центр дерматологии и инфекционных заболеваний» МЗ РК (свидетельство №1624)
- 2025 — Цикл «Функциональная диагностика в кардиологии» (120 часов), НАО «Медицинский университет Астана» (свидетельство №KZ89VWF00303427)`,
    kz: `Біліктілікті арттыру курстары (соңғы 5 жыл ішінде):
- 2023 — «Балалардағы эхокардиография негіздері» циклі (240 сағат), «Ұлттық ғылыми кардиохирургия орталығы» НАҚ (№362 куәлік)
- 2023 — «Кардиологиядағы интервенциялық технологиялар» циклі (120 сағат), ҚР ДСМ «Қазақ дерматология және жұқпалы аурулар ғылыми орталығы» ШЖҚ РМК (№1624 куәлік)
- 2025 — «Кардиологиядағы функционалдық диагностика» циклі (120 сағат), «Астана медициналық университеті» НАҚ (№KZ89VWF00303427 куәлік)`,
  },
};
